import { render, staticRenderFns } from "./MarketsView.vue?vue&type=template&id=dd9fa60e&scoped=true"
import script from "./MarketsView.vue?vue&type=script&lang=js"
export * from "./MarketsView.vue?vue&type=script&lang=js"
import style0 from "./MarketsView.vue?vue&type=style&index=0&id=dd9fa60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9fa60e",
  null
  
)

export default component.exports